import { Box } from '@material-ui/core';
import SplashScreen from 'components/SplashScreen';
import Cookies from 'js-cookie';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { signIn } from 'redux/slice/login';

const AutoFaraAuthLogin = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const token = Cookies.get('token');

	React.useLayoutEffect(() => {
		if (token) {
			const logoutCallback = Cookies.get('logout_callback');

			dispatch(signIn({ token, logout_callback: logoutCallback }));

			setTimeout(() => {
				navigate({ pathname: '/home' });
			}, 1000);
		}
	});

	return (
		<Box>
			<SplashScreen />
		</Box>
	);
};

export default AutoFaraAuthLogin;
